import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import { DatePicker } from "antd";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import { useDispatch, useSelector } from "react-redux";
import { all_routes } from "../router/all_routes";
import { fetchAllTasksBoardAction, fetchTaskDataAction, updateStatusAction, updateStatusBoardAction } from "../../core/data/redux/actions/TaskActions";
import { RootState } from "../../core/data/redux/store";
import Select from "react-select";
import moment from "moment";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";

const KanbanView = () => {
  const routes = all_routes;
  const dispatch = useDispatch<any>();
  const [tasks, setTasks] = useState<any[]>([]);
  const initialFilters = {
    status: null,
    date: null,
    type: null,
    sort: 'latest',
    assignedTo: null,
  };
  const masters = useSelector((state: RootState) => state.admin.masters);
  const [filters, setFilters] = useState<any>(initialFilters);
  const [projectChoose, setProjectChoose] = useState<any>([]);
  const [users, setUsers] = useState<any>([]);
  const [statusChoose, setStatusChoose] = useState<any>([]);
  const [priorityChoose, setPriorityChoose] = useState<any>([]);
  const getModalContainer = () => {
    const modalElement = document.getElementById('modal-datepicker');
    return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
  };
  const [showAll, setShowAll] = useState<any>(false);
  const [visibleUsers, setVisibleUsers] = useState<any[]>([]);
  const [remainingCount, setRemainingCount] = useState<number>(0);
  const alldata = useSelector((state: RootState) => state.task.tasks);
  const fetchedTasks = useSelector((state: RootState) => state.task.tasks.tasksList);
  const [groupedTasks, setGroupedTasks] = useState<any[]>([]);
  useEffect(() => {
    dispatch(fetchTaskDataAction());
    dispatch(fetchAllTasksBoardAction(filters));
  }, []);
  const containersRef = useRef<HTMLDivElement[]>([]);
  useEffect(() => {
    // Group tasks by status
    if (fetchedTasks) {
      const grouped = fetchedTasks.reduce((acc: Record<string, any[]>, task: any) => {
        if (!acc[task.status]) {
          acc[task.status] = [];
        }
        acc[task.status].push(task);
        return acc;
      }, {});

      setGroupedTasks(Object.entries(grouped).map(([status, tasks]) => ({ status, tasks })));
    }
  }, [fetchedTasks]);
  const handleOnDragEnd = (result: any) => {
    if (!result.destination) return;

    const taskId = result.draggableId;
    const targetStatus = result.destination.droppableId;
    const sourceStatus = result.source.droppableId;

    if (targetStatus !== sourceStatus) {
      dispatch(updateStatusBoardAction({ taskId, status: targetStatus }, filters));
    }
  };

  useEffect(() => {
    if (masters) {
      const categories = masters.taskTypes?.map((data: any) => ({
        value: data,
        label: data,
      })) || [];

      const statuses = masters.taskStatuses?.map((data: any) => ({
        value: data,
        label: data,
      })) || [];

      const priorities = masters.taskPriority?.map((data: any) => ({
        value: data,
        label: data,
      })) || [];

      const userOptions = masters.users?.map((data: any) => ({
        value: data.userName,
        label: data.name,
        image: data.image,
      })) || [];

      setProjectChoose([{ value: "", label: "Select Department" }, ...categories]);
      setStatusChoose([{ value: "", label: "Select Status" }, ...statuses]);
      setPriorityChoose([{ value: "", label: "Select Priority" }, ...priorities]);
      setUsers([{ value: "", label: "Select User" }, ...userOptions]);
      if (userOptions) {
        setVisibleUsers(userOptions.slice(0, 5));
        setRemainingCount(userOptions.length - 5);
      }
    }
  }, [masters]);

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Kanban Board</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="index.html">
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Application</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Kanban Board
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              {/* <div className="dropdown">
                <Link
                  to="#"
                  className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  <i className="ti ti-file-export me-2" />
                  Export
                </Link>
                <ul className="dropdown-menu  dropdown-menu-end p-3">
                  <li>
                    <Link
                      to="#"
                      className="dropdown-item rounded-1"
                    >
                      <i className="ti ti-file-type-pdf me-1" />
                      Export as PDF
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      className="dropdown-item rounded-1"
                    >
                      <i className="ti ti-file-type-xls me-1" />
                      Export as Excel{" "}
                    </Link>
                  </li>
                </ul>
              </div> */}
              <div className="ms-2 mb-0 head-icons">
                <CollapseHeader />
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h4>Tasks</h4>
              <div className="d-flex align-items-center flex-wrap row-gap-3">
                <div className="avatar-list-stacked avatar-group-sm me-3">
                  {(showAll ? users : visibleUsers).map((user: any, index: number) => {
                    if (!user.value) return null;

                    return (
                      <span key={index} className="avatar avatar-rounded">
                        {user.image ? (
                          <img
                            className="border border-white"
                            src={`data:image/png;base64,${user.image}`}
                            alt="img"
                          />
                        ) : (
                          <ImageWithBasePath
                            className="border border-white"
                            src="assets/img/profiles/avatar-29.jpg"
                            alt="img"
                          />
                        )}
                      </span>
                    );
                  })}

                  {remainingCount > 0 && !showAll && (
                    <span
                      className="avatar avatar-rounded bg-primary text-white d-flex align-items-center justify-content-center"
                      style={{ cursor: "pointer" }}
                      onClick={() => setShowAll(true)}
                    >
                      +{remainingCount}
                    </span>
                  )}
                </div>
                <div className="d-flex align-items-center me-3">
                  <p className="mb-0 me-3 pe-3 border-end fs-14">
                    Total Task : <span className="text-dark"> {alldata.tasks?.total || 0} </span>
                  </p>
                  <p className="mb-0 me-3 pe-3 border-end fs-14">
                    Pending : <span className="text-dark"> {alldata.tasks?.pending || 0} </span>
                  </p>
                  <p className="mb-0 fs-14">
                    Completed : <span className="text-dark"> {alldata.tasks?.completed || 0} </span>
                  </p>
                </div>
                {/* <div className="input-icon-start position-relative">
                  <span className="input-icon-addon">
                    <i className="ti ti-search" />
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search Project"
                  />
                </div> */}
              </div>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-lg-4">
                  <div className="d-flex align-items-center flex-wrap row-gap-3 mb-3">
                    <h6 className="me-2">Priority</h6>
                    <ul
                      className="nav nav-pills border d-inline-flex p-1 rounded bg-light todo-tabs"
                      id="pills-tab"
                      role="tablist"
                    >
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link btn btn-sm btn-icon py-3 d-flex align-items-center justify-content-center w-auto active"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-home"
                          type="button"
                          role="tab"
                          aria-selected="true"
                        >
                          All
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link btn btn-sm btn-icon py-3 d-flex align-items-center justify-content-center w-auto"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-contact"
                          type="button"
                          role="tab"
                          aria-selected="false"
                        >
                          High
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link btn btn-sm btn-icon py-3 d-flex align-items-center justify-content-center w-auto"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-medium"
                          type="button"
                          role="tab"
                          aria-selected="false"
                        >
                          Medium
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link btn btn-sm btn-icon py-3 d-flex align-items-center justify-content-center w-auto"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-low"
                          type="button"
                          role="tab"
                          aria-selected="false"
                        >
                          Low
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-8">
                  <div className="d-flex align-items-center justify-content-lg-end flex-wrap row-gap-3 mb-3">
                    <div className="input-icon w-120 position-relative me-2">
                      <span className="input-icon-addon">
                        <i className="ti ti-calendar text-gray-9" />
                      </span>
                      <DatePicker
                        className="form-control datetimepicker"
                        format={{
                          format: "DD-MM-YYYY",
                          type: "mask",
                        }}
                        getPopupContainer={getModalContainer}
                        placeholder="Create Date"
                      />
                    </div>
                    <div className="input-icon w-120 position-relative me-2">
                      <span className="input-icon-addon">
                        <i className="ti ti-calendar text-gray-9" />
                      </span>
                      <DatePicker
                        className="form-control datetimepicker"
                        format={{
                          format: "DD-MM-YYYY",
                          type: "mask",
                        }}
                        getPopupContainer={getModalContainer}
                        placeholder="Due Date"
                      />
                    </div>
                    <div className="dropdown me-2">
                      <Select
                        name='status'
                        id='status'
                        className="react-select ms-2"
                        options={statusChoose}
                        value={statusChoose?.find((option: any) => option.value === filters.status) || statusChoose[0]}
                        placeholder="Select"
                      // onChange={handleFilterSelectchange}
                      />
                    </div>
                    {/* <div className="d-flex align-items-center border p-2 rounded">
                      <span className="d-inline-flex me-2">Sort By : </span>
                      <div className="dropdown">
                        <Link
                          to="#"
                          className="dropdown-toggle btn btn-white d-inline-flex align-items-center border-0 bg-transparent p-0 text-dark"
                          data-bs-toggle="dropdown"
                        >
                          Created Date
                        </Link>
                        <ul className="dropdown-menu  dropdown-menu-end p-3">
                          <li>
                            <Link
                              to="#"
                              className="dropdown-item rounded-1"
                            >
                              Created Date
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="#"
                              className="dropdown-item rounded-1"
                            >
                              Last 7 Days
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="#"
                              className="dropdown-item rounded-1"
                            >
                              Due Date
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
              <div className="tab-content" id="pills-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="pills-home"
                  role="tabpanel"
                >
                  <div className="d-flex align-items-start overflow-auto project-status pb-4">
                    <DragDropContext onDragEnd={handleOnDragEnd}>
                      {groupedTasks?.map((group) => (
                        <div key={group.status} className="p-3 rounded bg-transparent-secondary w-100 me-3" data-id={group.status} data-status={group.status}>
                          <div className="bg-white p-2 rounded mb-2">
                            <div className="d-flex align-items-center justify-content-between">
                              <div className="d-flex align-items-center">
                                <span className="bg-soft-pink p-1 d-flex rounded-circle me-2">
                                  <span className="bg-pink rounded-circle d-block p-1" />
                                </span>
                                <h5 className="me-2">{group.status}</h5>
                                <span className="badge bg-light rounded-pill">{group.tasks.length}</span>
                              </div>
                            </div>
                          </div>
                          <Droppable droppableId={group.status}>
                            {(provided) => (
                              <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                                className="kanban-drag-wrap"
                              >
                                {group.tasks.map((task: any, index: number) => (
                                  <Draggable key={task.id} draggableId={task.id} index={index}>
                                    {(provided, snapshot) => (
                                      <div
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        ref={provided.innerRef}
                                        className={`card kanban-card mb-2 ${snapshot.isDragging ? 'dragging' : ''}`} // Add dragging class
                                        style={{ ...provided.draggableProps.style, }} // Add inline styles if needed
                                        data-id={task.id}
                                        data-status={group.status}
                                      >
                                        <div className="card-body">
                                          <div className="d-flex align-items-center justify-content-between mb-3">
                                            <div className="d-flex align-items-center">
                                              <span className="badge bg-outline-dark me-2">
                                                {task.taskType}
                                              </span>
                                              <span className="badge bg-success badge-xs d-flex align-items-center justify-content-center">
                                                <i className="fas fa-circle fs-6 me-1" />
                                                {task.priority}
                                              </span>
                                            </div>
                                            <div className="dropdown">
                                              <Link
                                                to="#"
                                                className="d-inline-flex align-items-center"
                                                data-bs-toggle="dropdown"
                                              >
                                                <i className="ti ti-dots-vertical" />
                                              </Link>
                                              <ul className="dropdown-menu dropdown-menu-end p-3">
                                                <li>
                                                  <Link
                                                    to="#"
                                                    className="dropdown-item rounded-1"
                                                  >
                                                    <i className="ti ti-edit me-2" />
                                                    Edit
                                                  </Link>
                                                </li>
                                                <li>
                                                  <Link
                                                    to="#"
                                                    className="dropdown-item rounded-1"
                                                    data-bs-toggle="modal" data-inert={true}
                                                    data-bs-target="#delete_modal"
                                                  >
                                                    <i className="ti ti-trash me-2" />
                                                    Delete
                                                  </Link>
                                                </li>
                                              </ul>
                                            </div>
                                          </div>
                                          <div className="d-flex align-items-center justify-content-between mb-3">
                                            <Link to={`${routes.tasksdetails.replace(":taskId", task.id)}`}>
                                              <span className="avatar avatar-xs rounded-circle bg-warning me-2">
                                                <ImageWithBasePath
                                                  src="assets/img/icons/kanban-arrow.svg"
                                                  className="w-auto h-auto"
                                                  alt="Img"
                                                />
                                              </span>
                                              <h6 className="d-flex align-items-center">
                                                {task.title}{" "}
                                                <span className="fs-12 ms-2 text-gray">
                                                  {task.id}
                                                </span>
                                              </h6>
                                            </Link>
                                          </div>
                                          <div className="d-flex align-items-center border-bottom mb-3 pb-3">
                                            <div className="me-3 pe-3 border-end">
                                              <span className="fw-medium fs-12 d-block mb-1">
                                                Author
                                              </span>
                                              <p className="fs-12 text-dark">{task.assignedBy}</p>
                                            </div>
                                            <div className="me-3 pe-3 border-end">
                                              <span className="fw-medium fs-12 d-block mb-1">
                                                Assignee
                                              </span>
                                              <p className="fs-12 text-dark">{task.assignedTo}</p>
                                            </div>
                                            <div className="">
                                              <span className="fw-medium fs-12 d-block mb-1">
                                                Due on
                                              </span>
                                              <p className="fs-12 text-dark">{moment(task.dueDate)?.format("DD MMM YYYY")}</p>
                                            </div>
                                          </div>
                                          <div className="d-flex align-items-center justify-content-between">
                                            <div className="avatar-list-stacked avatar-group-sm me-3">
                                              <span className="avatar avatar-rounded" title={task.assignedTo}>
                                                {task.assignedToImage ? (
                                                  <img
                                                    className="border border-white"
                                                    src={`data:image/png;base64,${task.assignedToImage}`}
                                                    alt="img"
                                                  />
                                                ) : (
                                                  <ImageWithBasePath
                                                    className="border border-white"
                                                    src="assets/img/profiles/avatar-29.jpg"
                                                    alt="img"
                                                  />
                                                )}
                                              </span>

                                            </div>
                                            <div className="d-flex align-items-center">
                                              <Link
                                                to="#"
                                                className="d-flex align-items-center text-dark me-2"
                                              >
                                                <i className="ti ti-message-circle text-gray me-1" />
                                                {task.totalComments || 0}
                                              </Link>
                                              <Link
                                                to="#"
                                                className="d-flex align-items-center text-dark"
                                              >
                                                <i className="ti ti-paperclip text-gray me-1" />
                                                {task.totalFiles || 0}
                                              </Link>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </Draggable>
                                ))}
                                {provided.placeholder}
                              </div>
                            )}
                          </Droppable>
                        </div>
                      ))}
                    </DragDropContext>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2025 © HKCL.</p>
          <p>
            Designed &amp; Developed By{" "}
            <Link to="https://hkcl.in" target="_blank" className="text-primary">
              HKCL
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>

  );
};

export default KanbanView;
